var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
// This is an improvement of Math.round.
// It gives you the ability to round after a decimal.
export var roundTo = function (n, precision) {
    return Math.round(n * Math.pow(10, precision)) / Math.pow(10, precision);
};
export var size = function (width, height) {
    if (height === void 0) { height = width; }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n"])), width, height);
};
export var sizePx = function (n) { return size(n + "px"); };
// eslint-disable-next-line no-shadow
export var propSize = function (_a) {
    var size = _a.size;
    return sizePx(size);
};
export var propBgColor = function (_a) {
    var color = _a.color;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), color);
};
// eslint-disable-next-line no-shadow
export var propMargin = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 0 : _b;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: ", "px auto;\n"], ["\n  margin: ", "px auto;\n"])), size);
};
export var animationDelay = function (n) {
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    animation-delay: ", "s;\n  "], ["\n    animation-delay: ", "s;\n  "])), n);
};
export var propDelay = function (_a) {
    var delay = _a.delay;
    return animationDelay(delay);
};
export var getRange = function (n) {
    return Array.from(new Array(n).keys());
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map